// @ts-nocheck
import { post } from "@insite/client-framework/Services/ApiService";
import { SubmitAccountCreationFormApiParameter } from "@store/Framework/Store/Store/Components/AccountCreationForm/Handlers/SubmitAccountCreationForm";

export function postSubmitAccountCreationForm(parameter: any) {
    return post<SubmitAccountCreationFormApiParameter, void>(`/api/v1/registrations/activation-email`, parameter);
}
